import PropTypes from 'prop-types';
export const buttonTypePropType = PropTypes.oneOf(['button', 'reset', 'submit']);
export const buttonTypeArgType = {
  options: ['button', 'reset', 'submit'],
  control: {
    type: 'select'
  }
};
//# sourceMappingURL=consts.js.map